import { usePage } from '@inertiajs/react';
import { useState } from 'react';
import NavigationItem from './NavigationItem';

const navigation = {
    Klant: [
        {
            label: 'Organisatie',
            permissions: permissions => {
                return (
                    !permissions.includes('start at library view') ||
                    [
                        'view customers',
                        'view entities',
                        'view assessments',
                        'view documents',
                        'view corrections',
                        'view invoices',
                    ]?.some(permission => permissions.includes(permission))
                );
            },
            components: [
                'Invoices/CustomerIndexView',
                'Invoices/CreateOrUpdateView',
                'Invoices/ShowView',
                'Datahub/CustomerIndexView',
                'Contacts/IndexView',
                'Statistics/IndexView',
                'Logs/IndexView',
                'Entities/CustomerIndexView',
                'Entities/CreateOrUpdateView',
            ],
            children: [
                {
                    label: 'Algemeen',
                    permissions: permissions =>
                        permissions.includes('view customers'),
                    href: '/customers/:cid/info',
                },
                {
                    label: 'Instellingen',
                    href: '/customer/:cid/assessment?zekerheid',
                    permissions: permissions =>
                        permissions.includes('view entities'),
                },
                {
                    label: 'Datahub invitees',
                    href: '/customers/:cid/datahub-invitees',
                    permissions: permissions =>
                        permissions.includes('view datahub invitees'),
                    hasInertia: true,
                    components: ['Datahub/CustomerIndexView'],
                },
                {
                    label: 'Contactpersonen',
                    permissions: permissions =>
                        !permissions.includes('start at library view'),
                    href: '/customers/:cid/contacts',
                    hasInertia: true,
                    components: ['Contacts/IndexView'],
                },
                {
                    label: 'Entiteiten',
                    permissions: permissions =>
                        permissions.includes('view entities'),
                    href: '/customers/:cid/entities',
                    hasInertia: true,
                    components: [
                        'Entities/CustomerIndexView',
                        'Entities/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'Werknemers',
                    permissions: permissions =>
                        permissions.includes('view employees'),
                    href: '/customers/:cid/employees',
                },
                {
                    label: 'Dienstverbandgegevens',
                    href: '/communication/gegevensoverdracht',
                },
                {
                    label: 'Documenten',
                    permissions: permissions =>
                        permissions.includes('view documents'),
                    href: '/customer/:cid/library',
                },
                {
                    label: 'Correcties',
                    permissions: permissions =>
                        permissions.includes('view corrections'),
                    href: '/customer/:cid/corrections',
                },
                {
                    label: 'Facturen',
                    permissions: permissions =>
                        permissions.includes('view invoices'),
                    href: '/customers/:cid/invoices',
                    hasInertia: true,
                    components: [
                        'Invoices/CustomerIndexView',
                        'Invoices/CreateOrUpdateView',
                        'Invoices/ShowView',
                    ],
                },
                {
                    label: 'Statistieken',
                    href: '/customers/:cid/statistics',
                    hasInertia: true,
                    components: ['Statistics/IndexView'],
                },
                {
                    label: 'Logboek',
                    permissions: permissions =>
                        permissions.includes('view mail logs'),
                    href: '/customers/:cid/logs',
                    hasInertia: true,
                    components: ['Logs/IndexView'],
                },
            ],
        },
        {
            label: 'Diensten',
            permissions: permissions =>
                permissions.includes('view services menu item'),
            components: [
                'Quickscans/IndexView',
                'Quickscans/CreateOrUpdateView',
                'MissingData/EditView',
                'MissingData/OverviewView',
                'Questionnaires/CustomerIndexView',
                'Doelgroepregister/IndexView',
                'SROI/CustomerIndexView',
                'SROI/CustomerSettingView',
                'SROI/DashboardView',
                'SROI/EntitySettingView',
                'SROI/QuestionnaireSettingsView',
                'Signhost/IndexView',
                'NoRisk/CustomerIndexView',
                'NoRisk/CustomerSettingView',
                'NoRisk/EntitySettingView',
                'NoRisk/QuestionnaireSettingsView',
                'LKV/CustomerIndexView',
                'LKV/CustomerPendingDeletionView',
                'LKV/CustomerSettingView',
                'LKV/QuestionnaireSettingsView',
                'LKV/DgvIndexView',
                'WWCheck/BusinessRulesView',
                'WWCheck/ContractChecksView',
                'WWCheck/DashboardView',
                'WWCheck/SavingsView',
            ],
            children: [
                {
                    label: 'Whk controle',
                    permissions: permissions =>
                        permissions.includes('view whk controle'),
                    href: '/whk-controle',
                    services: [11],
                },
                {
                    label: 'Herbeoordelingen',
                    permissions: permissions =>
                        permissions.includes('view reassessments') ||
                        permissions.includes('view reassessments dashboard'),
                    href: '/customers/:cid/reassessments/dashboard',
                    services: [17, 30],
                },
                {
                    label: 'Legal Bezwaar',
                    permissions: permissions =>
                        permissions.includes('view legal objections'),
                    href: '/customers/:cid/services/legal-objections',
                    services: [32],
                },
                {
                    label: 'Legal Beroep',
                    permissions: permissions =>
                        permissions.includes('view legal appeals'),
                    href: '/customers/:cid/services/legal-appeals',
                    services: [33],
                },
                {
                    label: 'LKV scan',
                    permissions: permissions =>
                        permissions.includes('view lkv reports'),
                    href: '/lkvscan',
                    services: [12],
                    components: ['LKV/DgvIndexView'],
                },
                {
                    label: 'SV check',
                    href: '/services/3',
                    services: [15],
                },
                {
                    label: 'WW check',
                    permissions: permissions =>
                        permissions.includes('view ww check'),
                    href: '/customers/:cid/services/ww-check',
                    hasInertia: true,
                    components: [
                        'WWCheck/BusinessRulesView',
                        'WWCheck/ContractChecksView',
                        'WWCheck/DashboardView',
                        'WWCheck/SavingsView',
                    ],
                },
                {
                    label: 'LKV',
                    permissions: permissions =>
                        permissions.includes('view lkv'),
                    href: '/customers/:cid/services/lkv/employees',
                    services: [12],
                    hasInertia: true,
                    components: [
                        'LKV/CustomerIndexView',
                        'LKV/CustomerPendingDeletionView',
                        'LKV/CustomerSettingView',
                        'LKV/QuestionnaireSettingsView',
                    ],
                },
                {
                    label: 'No-riskpolis',
                    permissions: permissions =>
                        permissions.includes('view no-risk'),
                    href: '/customers/:cid/services/no-risk/employees',
                    services: [19],
                    hasInertia: true,
                    components: [
                        'NoRisk/CustomerIndexView',
                        'NoRisk/CustomerSettingView',
                        'NoRisk/EntitySettingView',
                        'NoRisk/QuestionnaireSettingsView',
                    ],
                },
                {
                    label: 'Scholing',
                    permissions: permissions =>
                        permissions.includes('view educations'),
                    href: '/education?tab=0&arrangement=ao-3',
                    services: [13],
                },
                {
                    label: 'SROI',
                    href: '/customers/:cid/services/sroi/dashboard',
                    permissions: permissions =>
                        permissions.includes('view sroi'),
                    services: [28],
                    hasInertia: true,
                    components: [
                        'SROI/CustomerIndexView',
                        'SROI/CustomerSettingView',
                        'SROI/DashboardView',
                        'SROI/EntitySettingView',
                        'SROI/QuestionnaireSettingsView',
                    ],
                },
                {
                    label: 'Quickscan',
                    permissions: permissions =>
                        permissions.includes('view quickscans'),
                    href: '/customers/:cid/services/quickscans',
                    hasInertia: true,
                    components: [
                        'Quickscans/IndexView',
                        'Quickscans/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'Doelgroepregister',
                    permissions: permissions =>
                        permissions.includes('view dgr'),
                    href: '/customers/:cid/services/dgr',
                    hasInertia: true,
                    components: ['Doelgroepregister/IndexView'],
                },
                {
                    label: 'Machtiging',
                    permissions: permissions =>
                        permissions.includes('view signhost'),
                    href: '/customers/:cid/services/signhost',
                    hasInertia: true,
                    components: ['Signhost/IndexView'],
                },
                {
                    label: 'Vragenlijsten',
                    permissions: permissions =>
                        permissions.includes('view questionnaires'),
                    href: '/customers/:cid/services/questionnaires',
                    hasInertia: true,
                    components: ['Questionnaires/CustomerIndexView'],
                },
                {
                    label: 'Vangnetregelingen',
                    href: '/customers/:cid/services/absenteeism',
                    permissions: permissions =>
                        permissions.includes(
                            'view absenteeism benefits requests'
                        ),
                    services: [31],
                },
                {
                    label: 'Ontbrekende gegevens',
                    permissions: permissions =>
                        permissions.includes('view missing data overview'),
                    href: '/customers/:cid/services/missing-data/edit',
                    hasInertia: true,
                    components: [
                        'MissingData/EditView',
                        'MissingData/OverviewView',
                    ],
                },
            ],
        },
    ],
    VCSW: [
        {
            label: 'UWV & BD',
            permissions: permissions =>
                [
                    'view assessments statuses',
                    'view entrants progress list',
                    'view entrants request overview',
                ]?.some(permission => permissions?.includes(permission)),
            components: [
                'OfficeContacts/IndexView',
                'OfficeContacts/CreateOrUpdateView',
            ],
            children: [
                {
                    label: 'Machtiging uitgevraagd',
                    permissions: permissions =>
                        permissions.includes('view lkv'),
                    href: '/services/lkv/overviews/authorization-requested',
                },
                {
                    label: 'Ingediend UWV',
                    permissions: permissions =>
                        permissions.includes('view lkv'),
                    href: '/services/lkv/overviews/authorization-signed',
                },
                {
                    label: 'Afgewezen UWV',
                    permissions: permissions =>
                        permissions.includes('view lkv'),
                    href: '/services/lkv/overviews/uwv-declined',
                },
                {
                    counter: 'assessment12',
                    label: 'Ingediend gemeente',
                    permissions: permissions =>
                        permissions.includes('view assessments statuses'),
                    href: '/assessments/status?s=12',
                },
                {
                    counter: 'dossiers',
                    label: 'ZW/WGA via UWV',
                    permissions: permissions =>
                        permissions.includes('view entrants progress list'),
                    href: '/entrants/progress-dossier',
                },
                {
                    counter: 'entrants',
                    label: 'Uitvraag instroom',
                    permissions: permissions =>
                        permissions.includes('view entrants request overview'),
                    href: '/entrants/request-overview',
                },
                {
                    label: 'Contactpersonen',
                    permissions: permissions =>
                        permissions.includes('view office contacts'),
                    href: '/office-contacts',
                    hasInertia: true,
                    components: [
                        'OfficeContacts/IndexView',
                        'OfficeContacts/CreateOrUpdateView',
                    ],
                },
            ],
        },
        {
            label: 'Status OCR/API',
            counter: 'failures',
            permissions: permissions =>
                [
                    'view temple menu icon',
                    'view statuses',
                    'view datahub statistics',
                    'view dgr monitor',
                ]?.some(permission => permissions.includes(permission)),
            components: [
                'Datahub/StatisticView',
                'Employees/InvalidBsnView',
                'Doelgroepregister/MonitorView',
            ],
            children: [
                {
                    label: 'Status OCR/API',
                    href: '/status',
                    permissions: permissions =>
                        ['view temple menu icon', 'view statuses']?.every(
                            permission => permissions.includes(permission)
                        ),
                },
                {
                    label: 'Ongeldige BSNs',
                    permissions: permissions =>
                        permissions.includes('view invalid bsns'),
                    href: '/invalid-bsns',
                    hasInertia: true,
                    components: ['Employees/InvalidBsnView'],
                },
                {
                    label: 'Datahub statistieken',
                    href: '/datahub/statistics',
                    permissions: permissions =>
                        permissions.includes('view datahub statistics'),
                    hasInertia: true,
                    components: ['Datahub/StatisticView'],
                },
                {
                    label: 'DGR-controles',
                    href: '/services/dgr/monitor',
                    hasInertia: true,
                    components: ['Doelgroepregister/MonitorView'],
                    permissions: permissions =>
                        permissions.includes('view dgr monitor'),
                },
            ],
        },
        {
            label: 'Overzichten',
            permissions: permissions =>
                permissions.includes('view lists internal'),
            components: [
                'LKV/NoAuthorisationView',
                'LKV/ResultsOverviewView',
                'LKV/CallListView',
            ],
            children: [
                {
                    label: 'Bezwaarschriften',
                    permissions: permissions =>
                        permissions.includes('view objection contents'),
                    href: '/objections',
                },
                {
                    label: 'Herbeoordelingen',
                    permissions: permissions =>
                        [
                            'view reassessments',
                            'view reassessments dashboard',
                        ]?.some(permission => permissions.includes(permission)),
                    href: '/reassessments/dashboard',
                },
                {
                    label: 'Klanten',
                    permissions: permissions =>
                        permissions.includes('view customers'),
                    href: '/customers',
                },
                {
                    label: 'LKV overzicht',
                    permissions: permissions =>
                        permissions.includes('view lkv reports'),
                    href: '/services/lkv/results',
                    hasInertia: true,
                    components: ['LKV/ResultsOverviewView'],
                },
                {
                    label: 'LKV bellijst',
                    permissions: permissions =>
                        permissions.includes('view lkv reports'),
                    href: '/services/lkv/calllist',
                    hasInertia: true,
                    components: ['LKV/CallListView'],
                },
                {
                    label: 'DGR positief zonder machtiging',
                    permissions: permissions =>
                        permissions.includes('view lkv reports'),
                    href: '/services/lkv/overviews/dgr-without-authorisation',
                    hasInertia: true,
                    components: ['LKV/NoAuthorisationView'],
                },
                {
                    isActive: path => {
                        return /^\/legal-objections\/overviews(\/dashboard)?$/.test(
                            path
                        );
                    },
                    label: 'Bezwaar overzicht',
                    permissions: permissions =>
                        permissions.includes('view legal objections'),
                    href: '/legal-objections/overviews',
                    services: [32],
                },
                {
                    label: 'Beroep overzicht',
                    permissions: permissions =>
                        permissions.includes('view legal appeals'),
                    href: '/legal-appeals/overviews',
                    services: [33],
                },
                {
                    // Both board levels live under this path, so the entry stays
                    // highlighted after drilling into one customer.
                    label: 'Whk bord',
                    permissions: permissions =>
                        permissions.includes('view whk board'),
                    href: '/services/whk/board',
                },
            ],
        },
        {
            label: 'Financieel',
            permissions: permissions =>
                ['view temple menu icon', 'view invoices']?.every(permission =>
                    permissions.includes(permission)
                ),
            href: '/invoices',
            hasInertia: true,
            components: ['Invoices/IndexView', 'Invoices/OverviewView'],
        },
        {
            label: 'Gebruikers',
            permissions: permissions =>
                ['view temple menu icon', 'view users']?.every(permission =>
                    permissions.includes(permission)
                ),
            href: '/users',
            hasInertia: true,
            components: ['Users/IndexView', 'Users/CreateOrUpdateView'],
        },
        {
            label: 'Contracten',
            permissions: permissions =>
                ['view temple menu icon', 'view contracts']?.every(permission =>
                    permissions.includes(permission)
                ),
            href: '/contracts',
            hasInertia: true,
            components: [
                'Contracts/IndexView',
                'Contracts/CreateOrUpdateView',
                'Contracts/Content/CreateOrUpdateView',
            ],
        },
        {
            label: 'Diensten instellingen',
            permissions: permissions =>
                permissions.includes('view questionnaires'),
            components: [
                'Questionnaires/Questions/IndexView',
                'Questionnaires/Questions/CreateOrUpdateView',
                'Questionnaires/Options/IndexView',
                'Questionnaires/Options/CreateOrUpdateView',
                'LKV/Questionnaires/CreateOrUpdateView',
                'NoRisk/Questionnaires/CreateOrUpdateView',
                'SROI/Questionnaires/CreateOrUpdateView',
            ],
            children: [
                {
                    label: 'Vragenlijst',
                    permissions: permissions =>
                        permissions.includes('view questionnaires'),
                    href: '/questionnaires/questions',
                    hasInertia: true,
                    components: [
                        'Questionnaires/Questions/IndexView',
                        'Questionnaires/Questions/CreateOrUpdateView',
                        'Questionnaires/Options/IndexView',
                        'Questionnaires/Options/CreateOrUpdateView',
                        'LKV/Questionnaires/CreateOrUpdateView',
                        'NoRisk/Questionnaires/CreateOrUpdateView',
                        'SROI/Questionnaires/CreateOrUpdateView',
                    ],
                },
            ],
        },
        {
            label: 'Instellingen',
            permissions: permissions =>
                [
                    'view resellers',
                    'view datahub invitees',
                    'view forms',
                    'view target groups',
                    'view parameters',
                    'view calculations',
                    'view roles',
                    'view sectors',
                    'view objection contents',
                    'view sms',
                ]?.some(permission => permissions.includes(permission)),
            components: [
                'SMS/IndexView',
                'TargetGroups/IndexView',
                'TargetGroups/CreateOrUpdateView',
                'Sectors/IndexView',
                'Sectors/CreateOrUpdateView',
                'Calculations/IndexView',
                'Calculations/CreateOrUpdateView',
                'Datahub/InviteeIndexView',
                'ObjectionContents/IndexView',
                'ObjectionContents/CreateOrUpdateView',
                'Resellers/IndexView',
                'Resellers/CreateOrUpdateView',
                'Roles/IndexView',
                'Roles/CreateOrUpdateView',
                'SectorParameters/IndexView',
                'SectorParameters/CreateOrUpdateView',
            ],
            children: [
                {
                    label: 'Resellers',
                    permissions: permissions =>
                        permissions.includes('view resellers'),
                    href: '/resellers',
                    hasInertia: true,
                    components: [
                        'Resellers/IndexView',
                        'Resellers/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'Datahub invitees',
                    permissions: permissions =>
                        permissions.includes('view datahub invitees'),
                    href: '/datahub-invitees',
                    hasInertia: true,
                    components: ['Datahub/InviteeIndexView'],
                },
                {
                    label: 'Vragenlijsten',
                    permissions: permissions =>
                        permissions.includes('view forms'),
                    href: '/forms',
                },
                {
                    label: 'Doelgroepen',
                    permissions: permissions =>
                        permissions.includes('view target groups'),
                    href: '/target-groups',
                    hasInertia: true,
                    components: [
                        'TargetGroups/IndexView',
                        'TargetGroups/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'Parameters',
                    permissions: permissions =>
                        permissions.includes('view parameters'),
                    href: '/sector-parameters',
                    hasInertia: true,
                    components: [
                        'SectorParameters/IndexView',
                        'SectorParameters/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'Berekeningen',
                    permissions: permissions =>
                        permissions.includes('view calculations'),
                    href: '/calculations',
                    hasInertia: true,
                    components: [
                        'Calculations/IndexView',
                        'Calculations/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'Rollen & Permissies',
                    permissions: permissions =>
                        permissions.includes('view roles'),
                    href: '/roles',
                    hasInertia: true,
                    components: ['Roles/IndexView', 'Roles/CreateOrUpdateView'],
                },
                {
                    label: 'Sectoren',
                    permissions: permissions =>
                        permissions.includes('view sectors'),
                    href: '/sectors',
                    hasInertia: true,
                    components: [
                        'Sectors/IndexView',
                        'Sectors/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'Bezwaren',
                    permissions: permissions =>
                        permissions.includes('view objection contents'),
                    href: '/objection-content',
                    hasInertia: true,
                    components: [
                        'ObjectionContents/IndexView',
                        'ObjectionContents/CreateOrUpdateView',
                    ],
                },
                {
                    label: 'SMS Messages',
                    permissions: permissions =>
                        permissions.includes('view sms'),
                    href: '/sms-messages',
                    components: ['SMS/IndexView'],
                    hasInertia: true,
                },
            ],
        },
        {
            label: 'Klant Dashboard',
            permissions: permissions =>
                permissions.includes('view customer dashboard'),
            href: '/dashboard/customer',
        },
    ],
};

const Navigation = () => {
    const { component } = usePage();

    // The group that contains the current page, which starts folded open.
    const currentGroup =
        Object.values(navigation)
            .flat()
            .find(item => item.children && item.components?.includes(component))
            ?.label ?? null;

    const [openItem, setOpenItem] = useState(currentGroup);
    const [previousGroup, setPreviousGroup] = useState(currentGroup);

    // The layout persists between pages, so a visit into another group opens
    // that group too. Set during render, so its disclosure mounts open.
    if (previousGroup !== currentGroup) {
        setPreviousGroup(currentGroup);

        if (currentGroup) {
            setOpenItem(currentGroup);
        }
    }

    return (
        <div className='relative flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white py-6'>
            <nav className='relative flex flex-1 flex-col'>
                <ul role='list' className='flex flex-1 flex-col gap-y-7'>
                    {Object.keys(navigation).map(section => (
                        <li key={section}>
                            <div className='px-4 text-xs/6 text-gray-400 uppercase'>
                                {section}
                            </div>

                            <ul role='list' className='mt-2 space-y-1'>
                                {navigation[section]?.map(item => (
                                    <NavigationItem
                                        item={item}
                                        // Remounted when the page moves into
                                        // it: a disclosure only opens itself
                                        // on mount.
                                        key={
                                            item.label === currentGroup
                                                ? `${item.label}:current`
                                                : item.label
                                        }
                                        isOpen={openItem === item.label}
                                        onToggle={() =>
                                            setOpenItem(prev =>
                                                prev === item.label
                                                    ? null
                                                    : item.label
                                            )
                                        }
                                    />
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default Navigation;
